import React from 'react';

export default function FormField({
  label,
  required,
  hint,
  error,
  children,
  className = '',
  labelClass,
  textMuted
}) {
  return (
    <div className={className}>
      {label && (
        <label className={`block mb-1 text-xs font-medium ${labelClass}`}>
          {label}{required ? ' *' : ''}
        </label>
      )}
      {children}
      {error ? (
        <p className="text-[11px] mt-1 text-red-500">{error}</p>
      ) : hint ? (
        <p className={`text-[11px] mt-1 ${textMuted}`}>{hint}</p>
      ) : null}
    </div>
  );
}

export function formInputClass(inputClass, { compact = false, fullWidth = true } = {}) {
  const width = fullWidth ? 'w-full ' : '';
  return `${width}px-3 ${compact ? 'py-2' : 'py-2.5'} rounded-xl border text-sm shadow-none focus:outline-none focus:ring-2 invalid:ring-0 invalid:shadow-none transition-all ${inputClass}`;
}
